const KNOWN_EXPLOITS_CHART_METRICS = [
  { key: 'inKnownExploitedVulnerabilities', label: 'In KEV' },
  { key: 'totalWeaponized', label: 'Total weaponized' },
  { key: 'totalReachable', label: 'Total reachable' },
  { key: 'totalPoc', label: 'Total PoC' },
  { key: 'totalActors', label: 'Total actors' },
  { key: 'totalAttacks', label: 'Total attacks' },
  { key: 'totalBotnets', label: 'Total botnets' },
  { key: 'totalRansomware', label: 'Total ransomware' },
  { key: 'exploitCode', label: 'Exploit code' },
  { key: 'pocTotalActors', label: 'PoC total actors' },
  { key: 'pocTotalAttacks', label: 'PoC total attacks' },
  { key: 'pocTotalBotnets', label: 'PoC total botnets' },
  { key: 'pocTotalRansomware', label: 'PoC total ransomware' },
  { key: 'pocTotalExploitCode', label: 'PoC total exploit code' },
  { key: 'weaponizedTotalActors', label: 'Weaponized total actors' },
  { key: 'weaponizedTotalAttacks', label: 'Weaponized total attacks' },
  { key: 'weaponizedTotalBotnets', label: 'Weaponized total botnets' },
  { key: 'weaponizedTotalRansomware', label: 'Weaponized total ransomware' },
  { key: 'weaponizedTotalExploitCode', label: 'Weaponized total exploit code' }
];

const isPositiveMetricValue = value => {
  if (value === null || value === undefined || value === '') {
    return false;
  }
  const n = Number(value);
  return Number.isFinite(n) && n > 0;
};

export const buildKnownExploitsChartConfig = exploits => {
  const pairs = KNOWN_EXPLOITS_CHART_METRICS.map(({ key, label }) => {
    const raw = exploits?.[key];
    return { key, label, value: isPositiveMetricValue(raw) ? Number(raw) : null };
  }).filter(item => item.value != null);

  return {
    categories: pairs.map(p => p.label),
    data: pairs.map(p => p.value)
  };
};

export const valueOrFallback = value => {
  if (value === null || value === undefined || value === '') {
    return 'N/A';
  }

  return value;
};
